import React, { useEffect } from 'react';
import ArticleHero from '../components/Hero/ArticleHero';
import ArticleContainer from '../components/Article/ArticleContainer';
import Breadcrumb from '../components/Breadcrumb/Breadcrumb';

const News = () => {
    useEffect(()=> {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      },[]);
    return (
        <>
            <ArticleHero/>
            <Breadcrumb/>
            <ArticleContainer/>
            <hr className='border-3' style={{ borderColor: "var(--accent-color)" }} />
           <div className="container">
            <h1>About Shoora</h1>
            <p>Shoora is a next-generation professional services company creating value at the intersection of business, technology, and humanity. With our fiercely human approach, we deeply understand our customers—and their customers—to deliver practical, end-to-end solutions that drive meaningful impact. Backed by over 700 technology partners, our nearly 12,000 team members in ten countries and 49 offices help people and organizations dream bigger, move faster, and build better tomorrows for all. We’re honored to be consistently recognized as a great place to work, including being one of Fortune’s 100 Best Companies to Work For nine years running. Learn more at slalom.com.</p>
           </div>
        </>
    )
}

export default News;